// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._19qtk{color:#0a385a;font-size:14px;font-size:1.4rem;height:auto;margin:0;max-width:165px;white-space:normal}._19qtk .btn-inner{-ms-flex-pack:left;justify-content:left}.nRmzn{display:-ms-flexbox;display:flex;position:relative;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;background-color:#fff;border-radius:50%;height:24px;height:2.4rem;justify-content:center;overflow:hidden;width:24px;width:2.4rem}.SQq8f{height:100%;-o-object-fit:cover;object-fit:cover;width:auto}._2C6FR{color:#fff;display:block;font-weight:700}._3a2Hp,._2C6FR{font-size:12px;font-size:1.2rem;line-height:16px;line-height:1.6rem}._3a2Hp{color:#0a385a;display:-webkit-box;-webkit-line-clamp:2;overflow:hidden;text-overflow:ellipsis;-webkit-box-orient:vertical;text-align:left}._3DE-6{color:#6f7ea2}", ""]);
// Exports
exports.locals = {
	"root": "_19qtk",
	"logo": "nRmzn",
	"logo__img": "SQq8f",
	"logo__initials": "_2C6FR",
	"label": "_3a2Hp",
	"enrollCode": "_3DE-6"
};
module.exports = exports;
